import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "@/components/landing/Hero";
import Tiles from "@/components/landing/Tiles";
import Footer from "@/components/landing/Footer";
import StickyCTA from "@/components/landing/StickyCTA";
import VIPPage from "@/pages/VIPPage";
import VIPThankYou from "@/pages/VIPThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import "@/App.css";

function Landing() {
  return (
    <>
      <main>
        <Hero />
        <Tiles />
        <Footer />
      </main>
      <StickyCTA />
    </>
  );
}

function App() {
  return (
    <div className="App relative">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/vip" element={<VIPPage />} />
          <Route path="/vip/obrigada" element={<VIPThankYou />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
